import config from '@/config'
import getPages from '@/pages.js'
import Vue from 'vue'
import store from '@/store/index'
import Router from 'vue-router'
import { isUndefined, isNullOrUndefined } from 'util'
import helper from '@/vueHelper'

Vue.use(Router)



export default function getRouter() {
  const router = new Router({
    base: config.serverBase,
    //mode: 'history',
    linkActiveClass: "active",
    routes: [
    //   {
    //   path: '/email_login',
    //   name: 'email_login',
    //   meta: {
    //     // requireAuth: true
    //   },

    //   component: () => import('@/views/email_login.vue')
    // },






    {
      name: 'login_member',
      path: '/login_member',
      component: () => import('@/views/login_member.vue'),
      meta: {

      },
    },


    {
      name: 'register',
      path: '/register',
      component: () => import('@/views/register.vue'),
      meta: {

      },
    },

    {
      name: 'validation',
      path: '/validation',
      component: () => import('@/views/validation.vue'),
      meta: {

      },
    },
    {
      name: 'success',
      path: '/success',
      component: () => import('@/views/success.vue'),
      meta: {

      },

    },
    {
      name: 'kdpsuccess',
      path: '/kdpsuccess',
      component: () => import('@/views/kdpsuccess.vue'),
      meta: {

      },

    },
    {
      name: 'bind',
      path: '/bind',
      component: () => import('@/views/bind.vue'),
      meta: {

      },
    },
    {
      name: 'pipl',
      path: '/pipl',
      component: () => import('@/views/pipl.vue'),
      meta: {

      },
    },

    {
      path: '/',
      name: 'home',
      meta: {
        title: "home",
      },
      component: () => import('@/views/home.vue'),
      children: [
        //...getPages(),
      ]
    },

    ]
  })

  router.beforeEach(async (to, from, next) => {
    // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
    // console.log('to=', to.fullPath, '| from=', from.fullPath);
    //reset

    let needClear = !isNullOrUndefined(to.params.clear) ? to.params.clear : true

    if (needClear) {
      helper.clearVuex(store);
    }


    //useless
    // if (to.name === 'login') {
    //   if (window.localStorage.getItem("ccrs_user") !== null) {
    //     next({
    //       path: '/Dashboard'
    //     });
    //   } else {
    //     next();
    //   }
    //   return;
    // }

    //let excludeAuth = ["/index"]

    //let requiresAuth = helper.includes(excludeAuth, to.path) || helper.includes(excludeAuth, to.name) ? false : true

    //if (requiresAuth) {
    //  //
    //  if (window.localStorage.getItem("ccrs_user") !== null) {
    //    var sysUserString = window.localStorage.getItem("ccrs_user") || "null";
    //    if (sysUserString == "[object Object]") {
    //      sysUserString = "null";
    //    }

    //    var sysUser = JSON.parse(sysUserString);

    //    if (sysUser && store.state.user !== sysUser) {
    //      store.dispatch("actionSetUser", sysUser);
    //      store.dispatch("actionSetToken", window.localStorage.getItem("ccrs_token"));
    //    }

    //    let hasAccess = helper.hasAccess(to.meta.access_code);
    //    if (hasAccess) {
    next();
    //      } else {
    //        $(".bs-tooltip-right").remove();
    //        next({
    //          path: '/*',
    //          query: {
    //            msg: `You don't have permission to access on this page (CODE:${to.meta.access_code})`,
    //          }
    //        });
    //      }
    //      // next();
    //    } else {
    //      next({
    //        path: '/index',
    //        query: { redirect: to.fullPath }
    //      });
    //    }
    //    // console.log('token?', store.state.token);
    //    // if (window.localStorage.getItem("ccrs_user") === '' || window.localStorage.getItem("ccrs_user") === null) {
    //    //   // 轉跳到 login page
    //    //   next({
    //    //     path: '/login'
    //    //   });
    //    // } else {
    //    //   next(); // 往下繼續執行
    //    // }
    //  } else {
    //    next(); // 往下繼續執行
    //  }
  });

  return router;
}
